<script setup lang="ts">
  import type { IMenuItem } from '@/components/sidebar-menu/types'

  const props = defineProps<{
    menuItems: IMenuItem[]
  }>()

  const activeItem = computed(() => {
    return props.menuItems.filter((item: any) => item.active)[0]
  })

  const open = ref(false)
</script>

<template>
  <CollapsibleRoot
    v-model:open="open"
    class="container flex flex-col gap-2 bg-grey py-6"
  >
    <CollapsibleTrigger class="flex w-full items-center justify-between rounded-xs bg-white px-4 py-3 text-left">
      <span class="w-full pr-1">
        <template v-if="activeItem">
          {{ activeItem.name }}
        </template>
      </span>

      <div
        class="text-bt-blue-ui"
        :class="{ 'rotate-90': !open, '-rotate-90': open }"
      >
        <Icon name="common/chevron-right" />
      </div>
    </CollapsibleTrigger>

    <CollapsibleContent
      class="overflow-hidden rounded-xs shadow-sidebar data-[state=closed]:animate-slide-up data-[state=open]:animate-slide-down"
    >
      <ul class="list-none bg-white p-2">
        <li
          v-for="item in menuItems"
          :key="item.href"
        >
          <NuxtLink
            :to="item.href"
            class="block w-full px-2 py-3 no-underline"
            :class="{ 'rounded-xs bg-divider': item.active }"
            external
          >
            {{ item.name }}
          </NuxtLink>
        </li>
      </ul>
    </CollapsibleContent>
  </CollapsibleRoot>
</template>
